import { render, staticRenderFns } from "./jjvc_product_white_list.vue?vue&type=template&id=6843da36&scoped=true&"
import script from "./jjvc_product_white_list.vue?vue&type=script&lang=js&"
export * from "./jjvc_product_white_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843da36",
  null
  
)

component.options.__file = "jjvc_product_white_list.vue"
export default component.exports